import KyeEmployee from './employee'

export default KyeEmployee



// WEBPACK FOOTER //
// ./src/public/components/kye-employee/index.js